export const apiUrl = process.env.REACT_APP_API_URL;
export const mapsUrl = process.env.REACT_APP_MAPS_URL;

export const casLoginUrl = process.env.REACT_APP_CAS_LOGIN_URL;
export const casLogoutUrl = process.env.REACT_APP_CAS_LOGOUT_URL;
